import React from "react";
import cls from "@/features/Header/styles.module.scss";
import { FlexRow } from "@/ui/FlexContainer/FlexContainer";
import { ButtonFirefliesIcon } from "@/assets/icons";
import { useUserDataContext } from "@/contexts/UserContext";
import Typography from "@/ui/Typography/Typography";

interface LightBalanceProps {}

export default function LightBalance(props: LightBalanceProps) {
  const { userData } = useUserDataContext();

  if (!userData) return null;

  return (
    <FlexRow alignItems="center" className={cls.lightBalance}>
      <div className={cls.ButtonFirefliesIconBlock}>
        <ButtonFirefliesIcon />
      </div>

      <Typography size="xl" color="var(--text-text-primary-inverse)">
        {userData.light.energy_count}
        <Typography
          size="xl"
          component="span"
          color="rgba(255, 255, 255, 0.45)"
        >
          /7
        </Typography>
      </Typography>
      <div className={cls.avatar}>
        <img src="/images/user_placeholder.png" />
      </div>
    </FlexRow>
  );
}
